import { Menu } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet.tsx';
import { BrandLink } from './sidebar.tsx';

const iconButton =
  'text-muted-foreground hover:text-foreground hover:bg-accent grid size-8 place-items-center rounded-md transition-colors';

/** The phone's bar above the page: a menu button that opens the sidebar as a drawer, and the logo. */
export function MobileTopbar({ sidebar }: { sidebar: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <header className="shrink-0 px-3">
        <div className="flex h-14 w-full items-center gap-3">
          <SheetTrigger className={iconButton} aria-label="Open menu">
            <Menu className="size-5" />
          </SheetTrigger>
          <BrandLink />
        </div>
      </header>
      <SheetContent
        side="left"
        aria-describedby={undefined}
        className="w-auto max-w-none border-0 bg-transparent p-2 shadow-none [&>button:last-child]:top-[35px] [&>button:last-child]:right-6"
        // Any link closes it, the current page's included.
        onClick={(e) => (e.target as Element).closest('a') && setOpen(false)}
      >
        <SheetTitle className="sr-only">Menu</SheetTitle>
        {sidebar}
      </SheetContent>
    </Sheet>
  );
}
